import { defineComponent as _defineComponent } from 'vue';
import { VContainer, VRow, VCol, VIcon, VSimpleTable } from "vuetify/lib";
import CodePreview from '../../components/CodePreview.vue';
import DemoSection from '../../components/DemoSection.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosChipDemo',
    setup(__props) {
        const configProps = [
            { name: 'textLength', type: 'number', default: '15', desc: 'Número de caracteres antes de truncar el texto.' },
            { name: 'forceTooltip', type: 'boolean', default: 'false', desc: 'Fuerza a mostrar el tooltip incluso si el texto no está truncado.' },
            { name: 'tooltipContent', type: 'string | (item) => string', default: "''", desc: 'Contenido personalizado para el tooltip. Puede ser un string o una función.' },
        ];
        return { __sfc: true, configProps, VContainer, VRow, VCol, VIcon, VSimpleTable, CodePreview, DemoSection };
    }
});
